import { i18n } from '@fs/zion-locale'

export default {
  divideImageGroup: () => i18n.t('internal.updateDividers.divideImageGroup', 'Divide Image Group'),
  heading: () => i18n.t('internal.updateDividers.heading', 'Image Group Dividers'),
  dividedSubheading: () =>
    i18n.t(
      'internal.updateDividers.dividedSubHeading',
      'Adjust the divisions that separate the image group into items.'
    ),
  undividedSubheading: () =>
    i18n.t(
      'internal.updateDividers.undividedSubheading',
      'Create the divisions that will separate the image group into items.'
    ),
  updateDividers: () => i18n.t('internal.updateDividers.updateDividers', 'Update Dividers'),
}
